import $ from 'jquery'
$(() => {
  // $('.p-faq_dt').click(function () {
  //   // $(this).toggleClass('active');
  //   $(this).next('.p-faq_dd').slideToggle()
  // })

  $('.p-faq_dt').on('click', function () {
    $(this).toggleClass('-active')
    $(this).next('.p-faq_dd').slideToggle()
  })
})
